(() => {
  const root = document.querySelector('[data-panu-request]');
  if (!root) return;

  const form = root.querySelector('#PanuSupplyRequest');
  const product = root.querySelector('[data-request-product]');
  const format = root.querySelector('[data-request-format]');
  const whatsappButton = root.querySelector('[data-request-whatsapp]');
  const formats = {
    fiordilatte: ['Formato da concordare', 'Quantità in kg'],
    provola: ['300 g', '500 g', 'Altro / da concordare'],
    bufala: ['250 g', '500 g', '750 g', '1 kg']
  };

  const slugForSelection = () => product.options[product.selectedIndex]?.dataset.slug || '';

  const updateFormats = () => {
    const values = formats[slugForSelection()] || [];
    format.innerHTML = '';
    const first = document.createElement('option');
    first.value = '';
    first.textContent = values.length ? 'Seleziona il formato' : 'Seleziona prima il prodotto';
    format.appendChild(first);
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      format.appendChild(option);
    });
  };

  const requestedProduct = new URLSearchParams(window.location.search).get('prodotto');
  if (requestedProduct) {
    const option = [...product.options].find((item) => item.dataset.slug === requestedProduct);
    if (option) product.value = option.value;
  }
  updateFormats();
  product.addEventListener('change', updateFormats);

  whatsappButton.addEventListener('click', () => {
    const required = [
      form.querySelector('[name="contact[Nome attività]"]'),
      form.querySelector('[name="contact[name]"]'),
      form.querySelector('[name="contact[phone]"]'),
      product,
      format,
      form.querySelector('[name="contact[Quantità indicativa]"]')
    ];
    const invalid = required.find((field) => !field.value.trim());
    if (invalid) {
      invalid.focus();
      invalid.reportValidity();
      return;
    }

    const value = (name) => form.querySelector(`[name="${name}"]`)?.value.trim() || 'non indicato';
    const lines = [
      'Buongiorno Rosario, vorrei richiedere una fornitura Panù.',
      '',
      `Attività: ${value('contact[Nome attività]')}`,
      `Referente: ${value('contact[name]')}`,
      `Telefono: ${value('contact[phone]')}`,
      `Prodotto: ${product.value}`,
      `Formato: ${format.value}`,
      `Quantità: ${value('contact[Quantità indicativa]')}`,
      `Comune: ${value('contact[Comune e provincia]')}`,
      `Note: ${value('contact[body]')}`
    ];
    const number = root.dataset.whatsapp.replace(/\D/g, '');
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener');
  });
})();
